// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const AssetLifecycleStateSchema = z.enum(['ACTIVE','ARCHIVED'] as const);

export type AssetLifecycleStateType = `${z.infer<typeof AssetLifecycleStateSchema>}`

export default AssetLifecycleStateSchema;
